export default {
  sidebar: {
    config: 'Config',
    jobScheduleConfig: 'Job Schedule Config',
    jobSchedule: 'Job Schedule',
    daily: 'Daily',
    schedule: 'Schedule',
  },
};
